// extracted by mini-css-extract-plugin
export default {"container":"feed-ingredient_container__JyJSU","price":"feed-ingredient_price__hLe9f","name":"feed-ingredient_name__k6N55"};